import { ENDPOINT } from '~/constants/endpoints';

import { type UUID } from '~/types/common';

import { type KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

/**
 * Deletes a company.
 *
 * @param companyId - The company ID to delete.
 * @param options - Additional request options.
 *
 * @see https://app.dev.vestigas.com/redoc#tag/VESTIGAS-Admin-Company/operation/delete_company_vadmin_companies__company_id__delete
 */
export async function deleteCompany(
  companyId: UUID,
  options?: KyRequestOptions,
): Promise<void> {
  // A successful deletion returns 204 No Content, so there is no response body to validate.
  await vestigasApi.delete(ENDPOINT.COMPANY.DELETE(companyId), {
    ...options,
    retry: 0,
    timeout: false,
  });
}
